export default function MosaicIcon() {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 7.5C0 3.35786 3.35786 0 7.5 0H28.5C32.6421 0 36 3.35786 36 7.5V28.5C36 32.6421 32.6421 36 28.5 36H7.5C3.35786 36 0 32.6421 0 28.5V7.5ZM7.5 3C5.01472 3 3 5.01472 3 7.5V16.5H16.5V3H7.5ZM19.5 3V16.5H33V7.5C33 5.01472 30.9853 3 28.5 3H19.5ZM33 19.5H19.5V33H28.5C30.9853 33 33 30.9853 33 28.5V19.5ZM16.5 33V19.5H3V28.5C3 30.9853 5.01472 33 7.5 33H16.5Z"/>
        </svg>
    );
};